import { UniversalLink } from '@plone/volto/components';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  URL: {
    id: 'URL',
    defaultMessage: 'Sito web',
  },
  Account: {
    id: 'Account',
    defaultMessage: 'Account',
  },
  Linkedin: {
    id: 'Linkedin',
    defaultMessage: 'LinkedIn',
  },
  Twitter: {
    id: 'Twitter',
    defaultMessage: 'Twitter',
  },
  Telefono: {
    id: 'Telefono',
    defaultMessage: 'Numero di telefono',
  },
  Email: {
    id: 'Email',
    defaultMessage: 'Email',
  },
  PEC: {
    id: 'PEC',
    defaultMessage: 'PEC',
  },
  social: {
    id: 'social',
    defaultMessage: 'Social',
  },
  fax: {
    id: 'fax',
    defaultMessage: 'Fax',
  },
  Whatsapp: {
    id: 'Whatsapp',
    defaultMessage: 'Whatsapp',
  },
  Telegram: {
    id: 'Telegram',
    defaultMessage: 'Telegram',
  },
  Skype: {
    id: 'Skype',
    defaultMessage: 'Skype',
  },
});

export const renderPDCItemValue = (pdcValue, intl) => {
  switch (pdcValue?.pdc_type) {
    case 'URL':
    case 'Account':
    case 'Linkedin':
    case 'Twitter':
      return (
        <UniversalLink
          href={`${pdcValue?.pdc_value}`}
          aria-label={`${intl.formatMessage(messages[pdcValue.pdc_type])}: ${
            pdcValue?.pdc_value ?? ''
          }`}
        >
          {pdcValue?.pdc_value}
        </UniversalLink>
      );
    case 'Telefono':
      return (
        <a
          href={`tel:${pdcValue?.pdc_value}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${intl.formatMessage(messages[pdcValue.pdc_type])}: ${
            pdcValue?.pdc_value ?? ''
          }`}
        >
          {pdcValue?.pdc_value}
        </a>
      );
    case 'Whatsapp':
      return (
        <a
          href={`https://wa.me/${pdcValue?.pdc_value.replace(/\D/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${intl.formatMessage(messages[pdcValue.pdc_type])}: ${
            pdcValue?.pdc_value ?? ''
          }`}
        >
          {pdcValue?.pdc_value}
        </a>
      );
    case 'Telegram':
      // telegram must be username not phone number
      return (
        <a
          href={`https://t.me/${pdcValue?.pdc_value}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${intl.formatMessage(messages[pdcValue.pdc_type])}: ${
            pdcValue?.pdc_value ?? ''
          }`}
        >
          {pdcValue?.pdc_value}
        </a>
      );
    case 'Skype':
      // skype must be: unknown, should we use their js resources?
      // and then GDPR?
      // https://learn.microsoft.com/en-us/skype-sdk/skypeuris/skypeuritutorial_webpages?redirectedfrom=MSDN
      return (
        <a
          href={`skype:${pdcValue?.pdc_value}?call`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${intl.formatMessage(messages[pdcValue.pdc_type])}: ${
            pdcValue?.pdc_value ?? ''
          }`}
        >
          {pdcValue?.pdc_value}
        </a>
      );
    case 'Email':
    case 'PEC':
      return (
        <a
          href={`mailto:${pdcValue?.pdc_value}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${intl.formatMessage(messages[pdcValue.pdc_type])}: ${
            pdcValue?.pdc_value ?? ''
          }`}
        >
          {pdcValue?.pdc_value}
        </a>
      );
    default:
      return pdcValue?.pdc_value;
  }
};
